import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { Tag } from '@/components/elementary/Tag';
import Heading from '@/components/typography/Heading';
import { cn } from '@/lib/styles';
type FeatureCardProps = {
  readonly item: Data.Component<'shared.roadmap-item'>;
  readonly variant?: 'primary' | 'secondary';
};
function getCustomColors(tag: NonNullable<Data.Component<'shared.roadmap-item'>['tags']>[number]) {
  if (!tag?.customColors) return undefined;
  return {
    backgroundColor: tag.customColors.backgroundColor?.color,
    textColor: tag.customColors.textColor?.color,
    borderColor: tag.customColors.borderColor?.color
  };
}
export function FeatureCard(t0) {
  const $ = _c(10);
  const {
    item,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "primary" : t1;
  const isSecondary = variant === "secondary";
  const t2 = isSecondary ? "bg-neutral-light-300" : "bg-white";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("border border-neutral-light-600 rounded-2xl p-4.5 flex flex-col justify-between gap-5 transition-colors h-full", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== item.title) {
    t4 = <Heading tag="h4" fontSize="bodyBoldLarge" className="w-full">{item.title}</Heading>;
    $[2] = item.title;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== item.tags) {
    t5 = item.tags && item.tags.length > 0 && <div className="flex flex-wrap gap-2.5">{item.tags.map(_temp)}</div>;
    $[4] = item.tags;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = <div className={t3}>{t4}{t5}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp(tag) {
  if (!tag) {
    return null;
  }
  return <Tag key={tag.id} name={tag.name || ""} variant={tag.variant?.variant} size={tag.size?.size} customColors={getCustomColors(tag)} />;
}